import React, { Component } from "react";
import {
  Button,
  Input,
  TreeSelect,
  Modal,
  Icon,
} from "antd";
import PropTypes from "prop-types";
const typeListItem = [
  {
    title: "请选择",
    value: "0",
    key: "0",
  },
  {
    title: "启用",
    value: "1",
    key: "1",
  },
  {
    title: "禁用",
    value: "2",
    key: "2",
  },
];
class IndexLinkItem extends Component {
  // 默认属性
  static defaultProps = {
    newSecondSelectColor: "#1E9FFF",
  };
  // 静态类型分析
  static propTypes = {
    urlPic: PropTypes.string.isRequired, //图片
    urlName: PropTypes.string.isRequired, //名称
    urlAddress: PropTypes.string.isRequired, //链接地址
    urlStatus: PropTypes.string.isRequired, //状态
    createTime: PropTypes.string.isRequired, //创建时间
    createBy: PropTypes.string.isRequired, //创建时间
    changeDate: PropTypes.string.isRequired, //创建时间
  };
  constructor(props) {
    super(props);
    this.state = {
      typeKey: null,
      visible: false,
      urlName: this.props.urlName,
      urlAddress: this.props.urlAddress,
      id: "",
    };
  }
  // 编辑
  showModal = (id) => {
    this.state.id = id;
    this.state.typeKey = this.props.urlStatus === "false" ? "禁用" : "启用";
    this.setState({
      visible: true,
      id: this.state.id,
      typeKey: this.state.typeKey,
    });
  };

  handleOk = () => {
    let edit = {
      changeDate: this.props.changeDate,
      createBy: this.props.createBy,
      createTime: this.props.createTime,
      urlAddress: this.state.urlAddress,
      urlName: this.state.urlName,
      urlStatus: this.props.urlStatus,
      id: this.state.id,
      urlPic: this.props.urlPic,
    };
    this.props.getEditUpdateData(edit);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  onChange = () => {
    let enabled = this.state.enabled;
    this.setState({
      enabled: !enabled,
    });
  };
  render() {
    // 上传
    // const uploadButton = (
    //   <div>
    //     <Icon type={this.state.loading ? "loading" : "plus"} />
    //     <div style={{ color: "purple" }}>点击上传</div>
    //   </div>
    // );
    // const { imageUrl, enabled } = this.state;

    return (
      <div>
        <Modal
          title="编辑链接"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width="800px"
          bodyStyle={{ height: "380px" }}
          footer={null}
          centered
        >
          <div>
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: "10px" }}>链接图标</div>
              <div
                style={{
                  marginLeft: "25px",
                  width: "200px",
                  height: "62px",
                }}
              >
                <img
                  style={{
                    marginLeft: "25px",
                    objectFit: "cover",
                    maxHeight: "100%",
                  }}
                  src={this.props.urlPic}
                  alt=""
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>链接名称</div>
              <div style={{ marginLeft: "50px", width: "600px" }}>
                <Input
                  placeholder="请输入链接名称(不超过6个字符)"
                  value={this.state.urlName}
                  onChange={(e) => this.onChange1(e)}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>链接地址</div>
              <div style={{ marginLeft: "50px", width: "600px" }}>
                <Input
                  placeholder="请输入链接地址(不超过100个字符)"
                  value={this.state.urlAddress}
                  onChange={(e) => this.onChange2(e)}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>状态</div>
              <div style={{ marginLeft: "78px" }}>
                <TreeSelect
                  style={{ width: "200px" }}
                  value={this.state.typeKey}
                  treeData={typeListItem}
                  onChange={(value) => {
                    this.state.typeKey = value;
                    this.setState({});
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "50px",
              }}
            >
              <div>
                <Button type="primary" onClick={this.handleOk}>
                  保存
                </Button>
              </div>
              <div style={{ marginLeft: "20px" }}>
                <Button type="primary" onClick={this.handleCancel}>
                  取消
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
  onChange1(e) {
    this.setState({
      urlName: e.target.value,
    });
  }
  onChange2(e) {
    this.setState({
      urlAddress: e.target.value,
    });
  }
}

export default IndexLinkItem;
